var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:"home",staticClass:"home",attrs:{"id":"home"}},[_c('MenuHome'),_c('Banner',{attrs:{"msg":"Vue.js App"}}),_c('FeatureGrid'),_c('About'),_c('Articles'),_c('Contact'),_c('Map'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }